// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ClusterStatusObservation
 */
export interface ClusterStatusObservation {
  /**
   *
   * @type {string}
   * @memberof ClusterStatusObservation
   */
  kubernetesVersion?: string;
  /**
   *
   * @type {string}
   * @memberof ClusterStatusObservation
   */
  observedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ClusterStatusObservation
   */
  oidcIssuerUrl?: string;
}

/**
 * Check if a given object implements the ClusterStatusObservation interface.
 */
export function instanceOfClusterStatusObservation(
  value: object,
): value is ClusterStatusObservation {
  return true;
}

export function ClusterStatusObservationFromJSON(
  json: any,
): ClusterStatusObservation {
  return ClusterStatusObservationFromJSONTyped(json, false);
}

export function ClusterStatusObservationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ClusterStatusObservation {
  if (json == null) {
    return json;
  }
  return {
    kubernetesVersion:
      json['kubernetes_version'] == null
        ? undefined
        : json['kubernetes_version'],
    observedAt: json['observed_at'] == null ? undefined : json['observed_at'],
    oidcIssuerUrl:
      json['oidc_issuer_url'] == null ? undefined : json['oidc_issuer_url'],
  };
}

export function ClusterStatusObservationToJSON(
  json: any,
): ClusterStatusObservation {
  return ClusterStatusObservationToJSONTyped(json, false);
}

export function ClusterStatusObservationToJSONTyped(
  value?: ClusterStatusObservation | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    kubernetes_version: value['kubernetesVersion'],
    observed_at: value['observedAt'],
    oidc_issuer_url: value['oidcIssuerUrl'],
  };
}
